import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats the calendar date of a value WITHOUT any timezone conversion.
 *
 * Use for date-semantic, already-local values — e.g. a form's open/closed/approved
 * date, which Neo.Link stores as customer-local wall-clock (`GetNowDateTimeInCustomerTimeZone`).
 * `neoShortDate`/`neoDate` route through `NeoTableService.getISODatetimeString`, which appends a
 * `Z` to a naive datetime and re-converts to the viewer's timezone — shifting afternoon values
 * across midnight (NEO-3629). This pipe reads Y/M/D as-is so the displayed day matches the stored
 * day and the date filter.
 *
 * Output is fixed to AU format (`dd/MM/yyyy`) so it does not vary with the browser locale.
 *
 * Input  -> "2026-06-16T15:00:00" (naive local) | Date
 * Output -> "16/06/2026"
 */
@Pipe({
    name: 'neoLocalDate',
    standalone: false
})
export class NeoLocalDatePipe implements PipeTransform {
  transform(value?: Date | string): string {
    if (!value) return '';

    let year: number, month: number, day: number;
    if (typeof value === 'string') {
      const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
      if (!match) return value;
      [year, month, day] = [Number(match[1]), Number(match[2]), Number(match[3])];
    } else {
      [year, month, day] = [value.getFullYear(), value.getMonth() + 1, value.getDate()];
    }

    // Format the parsed components directly as AU dd/MM/yyyy — no Date/locale/timezone involved,
    // so the displayed day can never shift.
    const pad = (n: number): string => n.toString().padStart(2, '0');
    return `${pad(day)}/${pad(month)}/${year}`;
  }
}
